import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import {
    IdentityProviderDetails,
} from "@idw-types/data/identity-providers";
import { handleRequest } from "@utils/http-util";
import { injectIdentityProviderId } from "@utils/parameter-injector";

export const getIdentityProviderDetailsAxnAdminRequest = async (
    identityProviderId: string,
): Promise<{ data: IdentityProviderDetails, error: any }> => {
    const route = injectIdentityProviderId(apiRoutes.idpConfiguration.identityProviderConfig.axnAdmin.identityProviderWithId, identityProviderId);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};
